import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Configurator from './components/Configurator';
import AdminDashboard from './components/Admin/AdminDashboard';
import QuoteManagement from './components/Admin/QuoteManagement';
import './App.css';

const API_URL = process.env.REACT_APP_API_URL || '';

function App() {
  const [view, setView] = useState('configurator'); // 'configurator', 'admin', or 'quotes'
  const [isEmbedded, setIsEmbedded] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    // Detect if the app is embedded in an iframe
    setIsEmbedded(window.self !== window.top);

    // Check if user has a valid admin session
    const token = localStorage.getItem('authToken');
    if (token) {
      axios.get(`${API_URL}/api/auth/check`, {
        headers: { 'X-Auth-Token': token }
      }).then(response => {
        if (response.data.authenticated) {
          setIsAdmin(true);
        }
      }).catch(() => {
        // Token invalid, don't show admin nav
      });
    }
  }, []);

  // Update admin state when navigating to admin (in case they just logged in)
  const handleAdminAuth = () => {
    setIsAdmin(true);
  };

  // If embedded, only show configurator without navigation
  if (isEmbedded) {
    return (
      <div className="App">
        <Configurator />
      </div>
    );
  }

  return (
    <div className="App">
      <div className="app-nav">
        <button
          className={`nav-btn ${view === 'configurator' ? 'active' : ''}`}
          onClick={() => setView('configurator')}
        >
          Product Configurator
        </button>
        {isAdmin && (
          <>
            <button
              className={`nav-btn ${view === 'admin' ? 'active' : ''}`}
              onClick={() => setView('admin')}
            >
              Admin Panel
            </button>
            <button
              className={`nav-btn ${view === 'quotes' ? 'active' : ''}`}
              onClick={() => setView('quotes')}
            >
              Quote Requests
            </button>
          </>
        )}
        {!isAdmin && (
          <button
            className="nav-btn"
            onClick={() => setView('admin')}
          >
            Admin Login
          </button>
        )}
      </div>

      {view === 'configurator' && <Configurator />}
      {view === 'admin' && <AdminDashboard onLogin={handleAdminAuth} />}
      {view === 'quotes' && <QuoteManagement />}
    </div>
  );
}

export default App;
